import React, { useState } from "react";
const ScoreTypesStatsSection = ({ scoreTypeName, players, groupBy }) => {
    const [isOpen, setIsOpen] = useState(false);
    const groupByHole = () => {
        const grouped = {};
        players.forEach(({ playerName, holeNumber }) => {
            if (!grouped[holeNumber]) {
                grouped[holeNumber] = [];
            }
            grouped[holeNumber].push(playerName);
        });
        return grouped;
    };
    const groupByPlayer = () => {
        const grouped = {};
        players.forEach(({ playerName, holeNumber }) => {
            if (!grouped[playerName]) {
                grouped[playerName] = [];
            }
            grouped[playerName].push(holeNumber);
        });
        return grouped;
    };
    return React.createElement("div", { className: "ui message" },
        React.createElement("div", { className: "scoreTypeStatHeader", onClick: () => setIsOpen(prev => !prev) },
            React.createElement("div", { className: "header" },
                scoreTypeName,
                " (",
                players.length,
                ")"),
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 24 24", style: { rotate: `${isOpen ? 90 : 0}deg` } },
                React.createElement("path", { fill: "currentColor", d: "M10.5 16.3q-.2 0-.35-.137T10 15.8V8.2q0-.225.15-.362t.35-.138q.05 0 .35.15l3.625 3.625q.125.125.175.25t.05.275t-.05.275t-.175.25L10.85 16.15q-.075.075-.162.113t-.188.037" }))),
        isOpen &&
            React.createElement("ul", null, groupBy === 'hole' ?
                Object.entries(groupByHole())
                    .sort(([holeA], [holeB]) => Number(holeA) - Number(holeB))
                    .map(([holeNumber, playerNames]) => (React.createElement("li", { key: holeNumber },
                    React.createElement("strong", null,
                        "Hoyo ",
                        holeNumber,
                        ":"),
                    React.createElement("ul", null, playerNames.map((name, index) => (React.createElement("li", { key: index }, name)))))))
                :
                    Object.entries(groupByPlayer())
                        .sort(([playerA], [playerB]) => playerA.localeCompare(playerB))
                        .map(([playerName, holeNumbers]) => (React.createElement("li", { key: playerName },
                        React.createElement("strong", null,
                            playerName,
                            ":"),
                        " Hoyo ",
                        holeNumbers.sort((a, b) => a - b).join(', Hoyo '))))));
};
export default ScoreTypesStatsSection;
